module.exports = __webpack_public_path__ + "static/media/home.aaef52f9.svg";